"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchItemValidator = void 0;
const validateZodSchema_1 = require("../../../common/zodValidation/validators/validateZodSchema");
const searchResponse_schema_1 = require("../../schemas/search/searchResponse.schema");
const searchItemValidator = (data, extraValidation) => (0, validateZodSchema_1.validateZodSchema)(searchResponse_schema_1.searchItemSchema, data, extraValidation);
exports.searchItemValidator = searchItemValidator;
//# sourceMappingURL=searchItemValidator.js.map